import React from 'react';
import Div from '../components/Div.styled';
import EVMap from '../result/map/evMap';
import {config} from '../environment';
import EVMapIframe from '../result/evMapIframe';

const EVMapLanding = () => {
  if (config.EVMAP_ENABLED) {
    return (
      <Div customStyles={{height: '75vh', display: 'flex'}}>
        <EVMap postCode="3000" />
      </Div>
    );
  }

  return <EVMapIframe />;
};

export default EVMapLanding;
